import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from '@doxyme/ui';
import { Link } from './../../../../components/navigation';
import { ExtensionTypes, selectInstitution, selectUser, } from '../../../../store/features/system';
import { selectExtension } from '../../selectors';
import { isNativeAvailableForProAndClinic } from '../../utils';
import { get, some } from 'lodash';
import { MembershipType } from '../../../../store/features/system/types';
import { AvailableFor, TYPES, } from '../../../marketplace-admin/constants/constants';
export const ExtensionActionButton = ({ inFlight, handleChangeStatus, setIsOpenTerms, }) => {
    const user = useSelector(selectUser);
    const institution = useSelector(selectInstitution);
    const extension = useSelector(selectExtension);
    const { type, buttonValue, availableFor, isInstalled, termsUrl } = extension;
    const isAngularExtensionInstalled = useMemo(() => {
        return Boolean(get(institution, `institutionAccess.extensions_${extension.name}`));
    }, [institution, extension]);
    const installExtension = useCallback(() => {
        if (termsUrl) {
            setIsOpenTerms(true);
        }
        else {
            handleChangeStatus(ExtensionTypes.installed)();
        }
    }, [handleChangeStatus, setIsOpenTerms, termsUrl]);
    if (!Boolean(user) ||
        isNativeAvailableForProAndClinic(extension, user, institution)) {
        return null;
    }
    if (institution &&
        !some(user.institutionsMemberships, (membership) => {
            return (membership.institutionId === institution.id &&
                [MembershipType.owner, MembershipType.admin].includes(membership.role));
        })) {
        return null;
    }
    if (user.subscriptionType === 'free' &&
        availableFor === AvailableFor.PRO_CLINIC &&
        !institution) {
        return (<Link to="/account/subscription" className="button button--main" data-testid="free_for_pro-btn">
        <FormattedMessage id="account.marketplace.action-upgrade_account"/>
      </Link>);
    }
    if (isInstalled || isAngularExtensionInstalled) {
        return (<Button btnStyle="solid" size="medium" disabled={inFlight} onClick={handleChangeStatus(ExtensionTypes.uninstalled)} data-testid="uninstall-btn">
        <FormattedMessage id="account.marketplace.action-uninstall"/>
      </Button>);
    }
    if (type === TYPES.EXTENSION) {
        return (<Button btnStyle="solid" size="medium" disabled={inFlight} onClick={installExtension} data-testid="install-btn">
        <FormattedMessage id={institution === null
                ? 'account.marketplace.action-install'
                : 'account.marketplace.action-install-clinic'}/>
      </Button>);
    }
    if (type === TYPES.EXTERNAL_TOOL && buttonValue) {
        return (<a className="ui-button ui-button--solid--primary ui-button--medium" href={buttonValue} target="_blank" data-testid="external_tool-btn" rel="noreferrer">
        <FormattedMessage id="account.marketplace.action-external-tool"/>
      </a>);
    }
    return null;
};
